/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LookupArtistsResponseArtistsInnerMembersInner } from './LookupArtistsResponseArtistsInnerMembersInner';
import {
    LookupArtistsResponseArtistsInnerMembersInnerFromJSON,
    LookupArtistsResponseArtistsInnerMembersInnerFromJSONTyped,
    LookupArtistsResponseArtistsInnerMembersInnerToJSON,
} from './LookupArtistsResponseArtistsInnerMembersInner';

/**
 * 
 * @export
 * @interface CreateRecordingEnvelopePayloadArtistsInner
 */
export interface CreateRecordingEnvelopePayloadArtistsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadArtistsInner
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadArtistsInner
     */
    source?: CreateRecordingEnvelopePayloadArtistsInnerSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadArtistsInner
     */
    stageName?: string;
    /**
     * 
     * @type {Array<LookupArtistsResponseArtistsInnerMembersInner>}
     * @memberof CreateRecordingEnvelopePayloadArtistsInner
     */
    members?: Array<LookupArtistsResponseArtistsInnerMembersInner>;
    /**
     * fa (featuring, default), ofa (other featured) or nfa (non-featured)
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadArtistsInner
     */
    featuredStatus?: CreateRecordingEnvelopePayloadArtistsInnerFeaturedStatusEnum;
    /**
     * An existing artist to link, from the 4.4.1 lookup. Mutually exclusive with `source_id`.
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadArtistsInner
     */
    artistId?: string;
}


/**
 * @export
 */
export const CreateRecordingEnvelopePayloadArtistsInnerSourceEnum = {
    Discogs: 'discogs',
    Musicbrainz: 'musicbrainz'
} as const;
export type CreateRecordingEnvelopePayloadArtistsInnerSourceEnum = typeof CreateRecordingEnvelopePayloadArtistsInnerSourceEnum[keyof typeof CreateRecordingEnvelopePayloadArtistsInnerSourceEnum];

/**
 * @export
 */
export const CreateRecordingEnvelopePayloadArtistsInnerFeaturedStatusEnum = {
    Fa: 'fa',
    Ofa: 'ofa',
    Nfa: 'nfa'
} as const;
export type CreateRecordingEnvelopePayloadArtistsInnerFeaturedStatusEnum = typeof CreateRecordingEnvelopePayloadArtistsInnerFeaturedStatusEnum[keyof typeof CreateRecordingEnvelopePayloadArtistsInnerFeaturedStatusEnum];


/**
 * Check if a given object implements the CreateRecordingEnvelopePayloadArtistsInner interface.
 */
export function instanceOfCreateRecordingEnvelopePayloadArtistsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateRecordingEnvelopePayloadArtistsInnerFromJSON(json: any): CreateRecordingEnvelopePayloadArtistsInner {
    return CreateRecordingEnvelopePayloadArtistsInnerFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopePayloadArtistsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelopePayloadArtistsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sourceId': !exists(json, 'source_id') ? undefined : json['source_id'],
        'source': !exists(json, 'source') ? undefined : json['source'],
        'stageName': !exists(json, 'stageName') ? undefined : json['stageName'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(LookupArtistsResponseArtistsInnerMembersInnerFromJSON)),
        'featuredStatus': !exists(json, 'featuredStatus') ? undefined : json['featuredStatus'],
        'artistId': !exists(json, 'artist_id') ? undefined : json['artist_id'],
    };
}

export function CreateRecordingEnvelopePayloadArtistsInnerToJSON(value?: CreateRecordingEnvelopePayloadArtistsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source_id': value.sourceId,
        'source': value.source,
        'stageName': value.stageName,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(LookupArtistsResponseArtistsInnerMembersInnerToJSON)),
        'featuredStatus': value.featuredStatus,
        'artist_id': value.artistId,
    };
}

